export default __webpack_public_path__ + "static/media/web-preview.8720e583.webp";